export default {
  setCurrencyString: (value) => {
    const formattedValue = value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    return formattedValue;
  },

  // From 2024-10-31 to 31/10/2024
  setDateDisplay: (date) => {
    if (!date) return "";
    // Backend returns "yyyy-MM-ddTHH:mm:ss" (no Z, no offset) - already local time
    let stringDate = date.split('T')[0];
    const [year, month, day] = stringDate.split('-');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).toLocaleDateString();
  },
  setDateTimeDisplay: (date) => {
    if (!date) return "";
    // Backend retorna datas em horário de São Paulo (yyyy-MM-ddTHH:mm:ss ou com Z)
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  },
  setDateInput: (date) => {
    if (!date) return "";
    let stringDate = date.split('T')[0];
    return stringDate;
  },
};
